/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
import { useCookieConsent } from "../CookieConsent/CookieConsentProvider";

setOptions({ key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY });

const GoogleMapsApiContext = createContext<{
  placesLib?: google.maps.PlacesLibrary;
}>({});

function GoogleMapsApiProvider({ children }: { children: ReactNode }) {
  const { hasConsent } = useCookieConsent();
  const [placesLib, setPlacesLib] = useState<google.maps.PlacesLibrary>();

  useEffect(() => {
    async function importLibs() {
      const placesLib = await importLibrary("places");
      setPlacesLib(placesLib);
    }

    if (hasConsent("analytics")) {
      importLibs();
    }
  }, [hasConsent]);

  return <GoogleMapsApiContext.Provider value={{ placesLib }}>{children}</GoogleMapsApiContext.Provider>;
}

const useGoogleMapsApi = () => {
  return useContext(GoogleMapsApiContext);
};

export { GoogleMapsApiProvider, useGoogleMapsApi };
